import PropTypes from 'prop-types'
import ImmutableProptypes from 'react-immutable-proptypes'
import React, { PureComponent } from 'react'
import classnames from 'classnames'
import Select from 'react-select'
import { connect } from 'react-redux'

import styles from './styles.css'
import Icon from '_components/icon'
import FormElement from '_components/formElement'
import FormBody from '_components/formBody'

import CategoryTabBodySwipe from '../categoryTabBodySwipe'
import { updateLastActivityAt } from '_modules/user/actions'
import { createTodayItem } from '_modules/today-items/actions'
import { createTomorrowItem } from '_modules/tomorrow-items/actions'

const mapStateToProps = ({ todayItems, tomorrowItems, settings }) => ({
  todayItems,
  tomorrowItems,
  settings,
})

const mapDispatchToProps = {
  updateLastActivityAt,
  createTodayItem,
  createTomorrowItem,
}

class TaskForm extends PureComponent {
  static propTypes = {
    closePlusForm: PropTypes.func.isRequired,
    todayItems: ImmutableProptypes.map,
    tomorrowItems: ImmutableProptypes.map,
    settings: ImmutableProptypes.map,
    updateLastActivityAt: PropTypes.func.isRequired,
    createTodayItem: PropTypes.func.isRequired,
    createTomorrowItem: PropTypes.func.isRequired,
  }

  static defaultProps = {
    todayItems: new Map(),
    tomorrowItems: new Map(),
    settings: new Map(),
  }

  state = {
    taskName: '',
    selectedOption: null,
  }

  componentDidMount() {
    if (this.inputRef) this.inputRef.focus()
    document.addEventListener('keydown', this.onKeyDown)
  }

  componentWillUnmount() {
    document.removeEventListener('keydown', this.onKeyDown)
  }

  onChange = event => {
    const { id, value } = event.target
    this.setState({
      [id]: value,
    })
  }

  handleChange = selectedOption => {
    this.setState({ selectedOption })
  }

  onKeyDown = event => {
    if (event.key === 'Enter') {
      this.onSave()
    }
  }

  onSave = () => {
    let { taskName, selectedOption } = this.state
    const { closePlusForm } = this.props

    if (!taskName) {
      this.props.displayError('Missing Task Name')
      return
    }

    if (selectedOption === null) selectedOption = { value: 50, page: 'today', label: 'Today' }

    if (selectedOption.page === 'today') {
      this.createTodayItem(taskName)
    } else {
      this.createTomorrowItem(taskName, selectedOption.section)
    }
    this.resetPlusForm()
    closePlusForm()
  }

  onCancel = () => {
    const { closePlusForm } = this.props
    closePlusForm()
  }

  createTomorrowItem = (name, section) => {
    const { tomorrowItems: cards } = this.props

    const order = cards.reduce((prevVal, card) => {
      if (card.order > prevVal) {
        return card.order
      }
      return prevVal
    }, 0)

    const payload = {
      name,
      order: order + 1,
      section,
    }

    this.props.createTomorrowItem(payload)

    this.props.updateLastActivityAt({
      lastActivityAt: new Date(),
    })
  }

  createTodayItem = name => {
    const { todayItems: cards } = this.props

    const order = cards.reduce((prevVal, card) => {
      if (card.order > prevVal) {
        return card.order
      }
      return prevVal
    }, 0)

    const payload = {
      name,
      order: order + 1,
    }

    this.props.createTodayItem(payload)

    this.props.updateLastActivityAt({
      lastActivityAt: new Date(),
    })
  }

  resetPlusForm = () => {
    this.setState({
      taskName: '',
      selectedOption: null,
    })
  }

  selectOptions = () => {
    const { settings } = this.props
    return [
      { value: 50, page: 'today', label: 'Today' },
      { value: 0, page: 'recurring', section: 0, label: 'Recurring' },
      { value: 100, page: 'tasks', section: 100, label: settings.get('tomorrowSection1') },
      { value: 200, page: 'tasks', section: 200, label: settings.get('tomorrowSection2') },
      { value: 300, page: 'tasks', section: 300, label: settings.get('tomorrowSection3') },
      { value: 400, page: 'tasks', section: 400, label: settings.get('tomorrowSection4') },
    ]
  }

  render() {
    const { taskName, selectedOption } = this.state
    const customStyles = {
      control: (provided, state) => ({
        ...provided,
        backgroundColor: 'auto',
        border: ' 1px solid rgba(255,255,255,0.3)',
      }),
      placeholder: (provided, state) => ({ ...provided, fontSize: 16, color: 'white' }),
      singleValue: (provided, state) => ({ ...provided, fontSize: 16, color: 'white' }),
      input: (provided, state) => ({ ...provided, fontSize: 16, color: 'white' }),
      menu: (provided, state) => ({
        ...provided,
        backgroundColor: 'rgba(80,95,172,0.8)',
        fontSize: 16,
        color: 'white',
      }),
      option: (provided, { isFocused }) => {
        return {
          ...provided,
          color: isFocused ? 'black' : 'white',
        }
      },
    }

    const buttons = [
      { label: 'Save', onClick: this.onSave },
      { label: 'Cancel', onClick: this.onCancel },
    ]

    return (
      <CategoryTabBodySwipe>
        <FormBody buttons={buttons}>
          <FormElement label="Task">
            <input
              ref={input => (this.inputRef = input)}
              type="text"
              id="taskName"
              value={taskName}
              className={classnames(styles['form-input'])}
              onChange={this.onChange}
              autoComplete="off"
            />
          </FormElement>
          <FormElement label="Timeframe">
            <Select
              className={classnames(styles.singleSelectBox)}
              value={selectedOption}
              onChange={this.handleChange}
              options={this.selectOptions()}
              styles={customStyles}
              placeholder="Today"
            />
          </FormElement>
        </FormBody>
      </CategoryTabBodySwipe>
    )
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(TaskForm)



// WEBPACK FOOTER //
// ./src/components/categoryTabs/taskForm/index.js